import type { InviteFormErrorReason } from "@mirage/analytics/events/enums/invite_form_error_reason";
import i18n from "@mirage/translations";
import { EmailValidationResult } from "../types";

export const getResultMessage = (
  result: EmailValidationResult | null | undefined,
  isFssTeam: boolean,
):
  | {
      message: string | null;
      messageType: "info" | "none";
      loggedReason?: never;
    }
  | {
      message: string | null;
      messageType: "error";
      loggedReason: InviteFormErrorReason;
    } => {
  switch (result) {
    case EmailValidationResult.MALFORMED:
      return {
        message: i18n.t("invite_form_validation_result_malformed"),
        messageType: "error",
        loggedReason: "email_malformed",
      };
    case EmailValidationResult.INELIGIBLE_FOR_DASH_UNSPECIFIED:
      return {
        message: i18n.t(
          "invite_form_validation_result_ineligible_for_dash_unspecified",
        ),
        messageType: "error",
        loggedReason: "email_ineligible",
      };
    case EmailValidationResult.TEAM_MEMBER_ALREADY_WITH_DASH:
      return {
        message: i18n.t(
          "invite_form_validation_result_team_member_already_with_dash",
        ),
        messageType: "error",
        loggedReason: "email_already_has_product",
      };
    case EmailValidationResult.TEAM_MEMBER_PENDING_INVITE:
      return {
        message: i18n.t(
          "invite_form_validation_result_team_member_pending_invite",
        ),
        messageType: "error",
        loggedReason: "email_already_invited",
      };
    case EmailValidationResult.ASSOCIATED_WITH_DIFFERENT_TEAM:
      return {
        message: i18n.t(
          "invite_form_validation_result_associated_with_different_team",
        ),
        messageType: "error",
        loggedReason: "email_associated_other_team",
      };
    case EmailValidationResult.PAID_PERSONAL_OR_TRIAL:
      return {
        message: i18n.t("invite_form_validation_result_paid_personal_or_trial"),
        messageType: "error",
        loggedReason: "email_ineligible_plan",
      };
    case EmailValidationResult.NO_INVITE_PERMISSION:
      return {
        message: i18n.t("invite_form_validation_result_no_invite_permission"),
        messageType: "error",
        loggedReason: "invite_no_permission",
      };
    case EmailValidationResult.VALID_EMAIL:
      if (!isFssTeam) {
        return {
          message: null,
          messageType: "none",
        };
      }
      return {
        message: i18n.t("invite_form_validation_result_valid_email"),
        messageType: "info",
      };
    case EmailValidationResult.VALID_EMAIL_WORK_USER_FROM_DIFFERENT_TEAM:
      return {
        message: i18n.t(
          "invite_form_validation_result_work_user_from_different_team",
        ),
        messageType: "info",
      };
    case EmailValidationResult.VALIDATION_ERROR:
      return {
        message: i18n.t("invite_form_validation_result_validation_error"),
        messageType: "error",
        loggedReason: "email_unknown_error",
      };
    case EmailValidationResult.UNKNOWN:
      return {
        message: i18n.t("invite_form_validation_result_unspecified"),
        messageType: "error",
        loggedReason: "email_unknown_error",
      };
    case EmailValidationResult.DUPLICATE_EMAIL:
      return {
        message: i18n.t("invite_form_validation_result_duplicate_email"),
        messageType: "error",
        loggedReason: "email_duplicate",
      };
    case EmailValidationResult.PENDING_INVITE:
      return {
        message: i18n.t("invite_form_validation_result_pending_invite"),
        messageType: "error",
        loggedReason: "email_pending_invite",
      };
    case EmailValidationResult.ALREADY_ON_ANOTHER_TEAM:
      return {
        message: i18n.t(
          "invite_form_validation_result_already_on_another_team",
        ),
        messageType: "error",
        loggedReason: "email_on_other_team",
      };
    case EmailValidationResult.APPLE_RELAY_EMAIL:
      return {
        message: i18n.t("invite_form_validation_result_apple_relay_email"),
        messageType: "error",
        loggedReason: "email_apple_relay",
      };
    case EmailValidationResult.RECOVERABLE_USER:
      return {
        message: i18n.t("invite_form_validation_result_recoverable_user"),
        messageType: "error",
        loggedReason: "email_recoverable_user",
      };
    default:
      return {
        message: null,
        messageType: "none",
      };
  }
};
